import { isCatchUpFilter, isHeadlinesFilter } from "owa-mail-list-store";
import type { MailFolderTableQuery, TableView } from "owa-mail-list-store";
import { INITIAL_LOAD_ROW_COUNT, INITIAL_LOAD_ROW_COUNT_FOR_HEADLINES, INITIAL_LOAD_ROW_COUNT_LOCAL_TABLE, } from "../TableLoadingConstants";

export function getInitialLoadRowCountForTable(tableView: TableView | undefined): number {
    if (!tableView) {
        return INITIAL_LOAD_ROW_COUNT;
    }
    
    const mailTableQuery = tableView.tableQuery as MailFolderTableQuery;
    if (isHeadlinesFilter(mailTableQuery)) {
        return INITIAL_LOAD_ROW_COUNT_FOR_HEADLINES;
    }
    
    if (isCatchUpFilter(mailTableQuery)) {
        return INITIAL_LOAD_ROW_COUNT_LOCAL_TABLE;
    }
    
    return INITIAL_LOAD_ROW_COUNT;
}
